import React, { FunctionComponent } from "react";
import { slugify } from "../../utils";

interface SuggestionItemProps {
	item: any;
  langId: number;
	isSelected: boolean;
}

const SuggestionItem: FunctionComponent<SuggestionItemProps> = ({item, langId, isSelected}) => {

	const getContent = (): JSX.Element => {
		let withoutAnswer = true;

		let highlightText = item._source[`question_${langId}`];

      if (item.highlight) {
        if (item.highlight[`question_${langId}.standard_without_accent`]) {
          highlightText = item.highlight[`question_${langId}.standard_without_accent`][0];
        } else if (item.highlight[`question_${langId}`]) {
          highlightText = item.highlight[`question_${langId}`][0];
        } else if (item.highlight[`answer_${langId}.standard_without_accent`]) {
					withoutAnswer = false;
          highlightText = item.highlight[`answer_${langId}.standard_without_accent`];
        }
      }

			let element = (<span dangerouslySetInnerHTML={{__html: highlightText}}/>);
			if (!withoutAnswer) {
				element = (
					<div className="w-100 display-flex flex-column">
						<span className="hover-primary">{item._source[`question_${langId}`]}</span>
						<span className="italic faq-answer-suggest" dangerouslySetInnerHTML={{__html: highlightText + ' ...'}} />
					</div>
				);
			}

			return element;
	}

  const getUrl = (): string => {
    let href = '/help/q-'.concat(slugify(item._source[`question_${langId}`]), '/', item._id);
    if (item._source['is_link']) {
      href = item._source[`answer_${langId}`];
    }
    return href;
  };

	return (
		<a href={getUrl()} className={isSelected ? 'selected' : ''}>
			{getContent()}
		</a>
	);
};

export default SuggestionItem;
